export default __webpack_public_path__ + "ddc484c152f146b500f69cb6983bb436.png";